import { render } from "./WürfeltoolView.vue?vue&type=template&id=0fd2f90c"
import script from "./WürfeltoolView.vue?vue&type=script&lang=js"
export * from "./WürfeltoolView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__